import {slideToggle} from '../Utility/utils.js';

class TD_TABBED_UI {

  constructor( block ) {
    this.init(block);
    this.watchForContentChanges();
  }

  init(block) {
    this.block = block;
    this.contentWrap = this.block.querySelector('.tabbed_container__content_wrap');
    this.tabContainers = this.block.querySelectorAll('.tabbed_container__inner');
    this.tabsList = this.block.querySelector('.tabbed_container__nav');
    this.accordionTriggers = this.block.querySelectorAll('.tabbed_container__accordion_trigger');

    this.InitMarkup();
    
    this.tabListTriggers = this.tabsList.querySelectorAll('button');
    
    this.setLayoutState();

    this.watchTabClicks();

    this.resizeEvents();
  }

  setLayoutState() {
    let isDesktop;
    if(this.accordionTriggers.length > 0) {
      isDesktop = this.accordionTriggers[0].offsetParent === null ? true : false;
    }
    else {
      isDesktop = window.outerWidth > 990;
    }

    if(isDesktop && !this.block.classList.contains('layout-desktop')){
      this.block.classList.add('layout-desktop');
      this.block.classList.remove('layout-mobile');

      if(this.tabContainers.length > 0) {
        this.tabContainers.forEach( (tabContainer, index) => {
          tabContainer.classList.remove('active');
          this.tabListTriggers[index].setAttribute('aria-selected', 'false');
          this.accordionTriggers[index].setAttribute('aria-expanded', 'false');
          const innerContent = tabContainer.querySelector('.tabbed_container__inner_content');
          if(innerContent) {
            innerContent.style.display = null;
          }
        });
  
        this.tabContainers[0].classList.add('active');
        this.tabListTriggers[0].setAttribute('aria-selected', 'true');
      }
    }
    else if(!isDesktop && !this.block.classList.contains('layout-mobile')){
      this.block.classList.add('layout-mobile');
      this.block.classList.remove('layout-desktop');

      if(this.tabContainers.length > 0) {
        this.tabContainers.forEach( (tabContainer, index) => {
          tabContainer.classList.remove('active');
          this.tabListTriggers[index].setAttribute('aria-selected', 'false');
        });
      }
    }
    
    this.isDesktop = isDesktop;  
  }

  InitMarkup() {
    this.tabsList.innerHTML = '';

    this.tabContainers.forEach( tabContainer => {
      const label = tabContainer.getAttribute('data-label');

      // Build the tab toggle list
      const tabItem = document.createElement('li');
      tabItem.classList.add('tabbed_container__tab_item');
      const tabButton = document.createElement('button');
      tabButton.classList.add('tabbed_container__tab_trigger');
      tabButton.setAttribute('aria-controls', tabContainer.id);
      tabButton.setAttribute('aria-selected', 'false');
      tabButton.setAttribute('role', 'tab');
      tabButton.innerHTML = label;
      tabItem.appendChild(tabButton);
      this.tabsList.appendChild(tabItem);

      // Set the first tab as active
      if( this.tabContainers[0] === tabContainer ) {
        tabButton.setAttribute('aria-selected', 'true');
        tabContainer.classList.add('active');
      }
    });
  }

  watchTabClicks() {
    const clickHandler = (e) => {
      const trigger = e.currentTarget;
      
      if( trigger.getAttribute('aria-selected') === 'true' ) {
        return;
      }

      // Remove active class from all tabs
      this.tabContainers.forEach( tabContainer => {
        tabContainer.classList.remove('active');
      });
      this.tabListTriggers.forEach( tab => {
        tab.setAttribute('aria-selected', 'false');
      });

      // Add active class to the clicked tab
      const target = trigger.getAttribute('aria-controls');
      const targetTab = this.block.querySelector(`#${target}`);
      targetTab.classList.add('active');
      trigger.setAttribute('aria-selected', 'true');
    }

    if(this.tabListTriggers.length > 0) {
      this.tabListTriggers.forEach( trigger => {
        trigger.removeEventListener('click', clickHandler);
        trigger.addEventListener('click', clickHandler);
      });
    }

    if(this.accordionTriggers.length > 0) {
      this.accordionTriggers.forEach( trigger => {
        trigger.addEventListener('click', (e) => {
          const ariaExpanded = trigger.getAttribute('aria-expanded') === 'true' ? 'false' : 'true';
          trigger.setAttribute('aria-expanded', ariaExpanded);
          slideToggle(trigger.nextElementSibling);
        });
      });
    }
  }

  resizeEvents() {
    let resizeTimeout;
    window.addEventListener('resize', () => {
      clearTimeout(resizeTimeout);
      resizeTimeout = setTimeout(() => {
        this.isDesktop = this.setLayoutState(); 
      }, 100);
    });
  }

  watchForContentChanges() {
    // Watches for changes in the editor
    if(this.observer == undefined && document.body.classList.contains('wp-admin')) {
      this.observer = new MutationObserver((mutationsList, observer) => {
        let timeout = null;

        const reInitialize = () => {
          if(timeout){
            clearTimeout(timeout);
          }
          timeout = setTimeout(() => {
            this.init(this.block);
          }, 100);
        }

        for (const mutation of mutationsList) {
          if (mutation.type === 'childList') {
            console.log('Child nodes changed:', mutation);
            const nodes = mutation.addedNodes.length ? mutation.addedNodes : mutation.removedNodes;
            if(nodes.length) {
              for (let i = 0; i < nodes.length; i++) {
                const node = nodes[i];
                if(node.nodeType === 1 && node.classList.contains('wp-block-acf-tab-inner-container')) {
                  reInitialize();
                }
              }
            }
          }
          if (mutation.type === 'characterData') {
            console.log('Text content changed:', mutation);
            console.log(mutation.target.parentElement);
            if(mutation.target.parentElement.parentElement.classList.contains('tabbed_container__accordion_trigger')) {
              reInitialize();
            }
          }
        }
      });

      this.observer.observe(this.block, {
        childList: true,       // watches for the addition or removal of child elements
        subtree: true,         // watches all descendants
        characterData: true,   // watches changes to text content
        attributes: false      // set to true if you want to monitor attribute changes too
      });
    }
  }
}

document.addEventListener( 'DOMContentLoaded', function() {
  const blocks = document.querySelectorAll('.tabbed_container');

  if( blocks.length > 0 ) {
    blocks.forEach( block => {
      block.tabbedUI = new TD_TABBED_UI( block );
    });
  }
});

// Initialize dynamic block preview (editor).
if( window.acf ) {
  const initializeEditorBlock = function( $block ){
    const block = $block[0].querySelector('.tabbed_container');
    if(!!block){
      // Allow time for inner blocks to load
      setTimeout(() => {
        block.tabbedUI = new TD_TABBED_UI( block );
      }, 100);
    }
  }

  window.acf.addAction( 'render_block_preview/type=tabbed-container', initializeEditorBlock );
}
